import React, { useEffect, useState } from "react";
import { NB_DocPlaceSignModule_props } from "./type/docplace_batch_module.types";
import NbFormsModuleView from "./view/docplace_batch_module.view";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "../../components/loading";
import { Modal, Box, Typography } from "@mui/material";

import useAxios from "./hook/hook";
import {
  getBatchDocument,
  getBatchDocumentClearData,
} from "../../store/document/actions";
import { Message } from "./style/docplace_sign_module.styles";
import FileUploadDocPlace from "./components/fileUpload/fileUpload";
import Button from "@mui/material/Button";

const NbBatchModule: React.FC<
  NB_DocPlaceSignModule_props & { nameButton: string }
> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { fetchBatch, getResponse, getResponseLoading } = useAxios();

  const [dataS, setDataS] = useState<any[]>([]);
  const [pageActive, setPageActive] = useState("1");
  const [open, setOpen] = useState(false);
  const [originalData, setOriginalData] = useState<any[]>([]);

  const [totalFiles, setTotalFiles] = React.useState<File[]>([]);
  const updateFile = (files: File[]): void => {
    setTotalFiles(files);
  };
  const [updateAllFiles, setUpdateAllFiles] = React.useState(false);

  const formatStatus = (status: string) => {
    switch (status) {
      case "IN_PROGRESS":
        return "In Progress";
      case "COMPLETED":
        return "Completed";
      case "FAILED":
        return "Failed";
      default:
        return status;
    }
  };

  useEffect(() => {
    fetchBatch("/docs/Api/V1/Documents/Ingestion");
  }, []);

  useEffect(() => {
    if (getResponse && getResponse.length > 0) {
      let newObject: any[] = [];
      getResponse.map((item: any) =>
        newObject.push({
          name: item?.file_name,
          pages: item?.pages,
          id: item?.id,
          status: formatStatus(item?.status),
          progress: item?.progress,
          startTime: new Date(item?.start_time_spliter).toLocaleString(),
          endTime: new Date(item?.end_time_spliter).toLocaleString(),
        })
      );
      setDataS(newObject);
      setOriginalData(newObject);
    }
  }, [getResponse]);
  const handleUpload = () => {
    console.log("ID");
    setOpen(true);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    p: 4,
  };

  const handleSearch = (search: string) => {
    if (!search) {
      setDataS(originalData);
      return;
    }
    const filteredData = dataS.filter((item) =>
      item?.name?.toLowerCase().includes(search.toLowerCase())
    );
    setDataS(filteredData);
  };

  return (
    <>
      <LoadingComponent show={getResponseLoading} text={"Loading"} />
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Upload Files
          </Typography>
          <Typography
            component={"div"}
            id="modal-modal-description"
            sx={{ mt: 2 }}
          >
            <Message>
              Select the file(s) from your computer to upload. You can also drag
              and drop.
            </Message>
          </Typography>

          <FileUploadDocPlace
            uploadF={updateFile.bind(this)}
            updateAllFiles={updateAllFiles}
          ></FileUploadDocPlace>

          <Button
            variant="contained"
            color="success"
            onClick={() => {
              //
            }}
            sx={{ mt: 2 }}
            style={{ float: "right" }}
          >
            Start
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => setOpen(false)}
            sx={{ mt: 2, mr: 2 }}
            style={{ float: "right" }}
          >
            Cancel
          </Button>
        </Box>
      </Modal>

      <NbFormsModuleView
        nameButton={"Batch Upload"}
        title={"Batch Upload"}
        files={dataS}
        onClickUpload={handleUpload}
        onClickSearch={handleSearch}
      />
    </>
  );
};

export default NbBatchModule;
